// Comparator for sortable table columns: compares as numbers when both values are
// genuinely numeric (so "10" sorts after "2", not before it), otherwise falls back
// to locale-aware string comparison. Always returns a NEW sorted array (input is
// never mutated) since callers use this directly inside JSX render.
export function sortTableRows(rows, sortBy, ascending) {
  return [...rows].sort((a, b) => {
    const aVal = a[sortBy];
    const bVal = b[sortBy];
    const aNum = Number(aVal);
    const bNum = Number(bVal);
    const isNumeric = aVal !== null && aVal !== undefined && aVal !== ''
      && bVal !== null && bVal !== undefined && bVal !== ''
      && !isNaN(aNum) && !isNaN(bNum);

    const result = isNumeric
      ? aNum - bNum
      : (aVal ?? '').toString().localeCompare((bVal ?? '').toString());

    return ascending ? result : -result;
  });
}
